<template>
    <div class="modal" @click="outsideClick()">
        <loading-screen v-if="loadingScreen" />
        <div class="modal-box">
            <div class="close" @click="$emit('close')">
                <span>X</span>
            </div>
            <div class="modal-body">
              <div class="content">
                  <h1>{{getTitle()}}</h1>
                  <edit-allergies :values="customer" @updateCustomer="updateCustomer" @setLoadingScreen="setLoadingScreen" v-if="isMounted && field == 0" />
                  <edit-blood-type :values="customer" @updateCustomer="updateCustomer" @setLoadingScreen="setLoadingScreen" v-if="isMounted && field == 1" />
                  <edit-emergency-contact :values="customer" @updateCustomer="updateCustomer" @setLoadingScreen="setLoadingScreen" v-if="isMounted && field == 2" />
                  <edit-health-insurance :values="customer" @updateCustomer="updateCustomer" @setLoadingScreen="setLoadingScreen" v-if="isMounted && field == 3" />
                  <edit-picture :values="customer" @updateCustomer="updateCustomer" @setLoadingScreen="setLoadingScreen" v-if="isMounted && field == 4" />
              </div>
            </div>
        </div>
    </div>
</template>

<script>
  import EditAllergies from './EditAllergies'
  import EditBloodType from './EditBloodType'
  import EditEmergencyContact from './EditEmergencyContact';
  import EditHealthInsurance from './EditHealthInsurance';
  import EditPicture from './EditPicture.vue';

  export default {
    props: ['values', 'field'],
    name: "edit-modal",
    components: {EditAllergies, EditBloodType, EditEmergencyContact, EditHealthInsurance, EditPicture },
    data() {
          return {
              isMounted: false,
              loading: false,
              loadingScreen: false,
              customer: {},
              titles: [
                'Editar Alergias',
                'Editar Tipo sanguíneo',
                'Editar contato de emergência',
                'Editar plano de saúde',
              ],
          }
        },
    methods: {
      outsideClick() {
          if(event.target === event.currentTarget)
              this.$emit('close');
      },
      getTitle() {
        return this.titles[this.field];
      },
      setLoadingScreen(val) {
        this.loadingScreen = val;
      },
      updateCustomer(newCustomer) {
        this.$emit('updateCustomer', newCustomer);
        this.$emit('close');
      }
    },
    mounted() {
      this.customer = this.values;
      this.isMounted = true;
    }
  }
</script>

<style scoped>
  .modal-box {
    max-width: 425px;
  }
</style>



// WEBPACK FOOTER //
// src/components/CardHealthId/EditModal.vue